const PitchResult = {
    SwingingStrike:   { key: 'SS', name: 'Swinging Strike'},
    CalledStrike:     { key: 'CS', name: 'Called Strike'},
    Single:           { key: 'SE', name: 'Single'},
    Double:           { key: 'DE', name: 'Double'},
    Triple:           { key: 'TE', name: 'Triple'},
    HomeRun:          { key: 'HR', name: 'Home Run'},
    Ball:             { key: 'B', name: 'Ball'},
    IntentionalBall:  { key: 'IB', name: 'Intentional Ball'},
    FoulBall:         { key: 'FB', name: 'Foul Ball', shortName: 'Foul'},
    HitByPitch:       { key: 'HP', name: 'Hit by Pitch'},
    Error:            { key: 'E', name: 'Error'},
    ContactOut:       { key: 'CO', name: 'Contact Out'},
    Walk:             { key: 'BB', name: 'Walk'},
    StrikeoutSwinging:{ key: 'SSO', name: 'Swinging Strikeout', shortName: 'Swinging SO'},
    StrikeoutLooking: { key: 'CSO', name: 'Called Strikeout', shortName: 'Called SO'},
    Unidentified:     { key: 'UI', name: 'Unidentified'},

    listKeys() {
        return Object.values(this).map(item => item.key);
    }
};

export default PitchResult;